"use client";

import React, { useEffect, useState } from "react";
import MenuDrawer from "./menuDrawer";
import MenuStructure from "./menuStructure";
import { MenuOutlined } from "@ant-design/icons";
import { usePathname, useRouter } from "next/navigation";
import LoginButton from "./loginButton";
import Logo from "../logo/logo";


const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [mounted, setMounted] = useState(false);
  const pathname = usePathname();
  const router = useRouter();

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Initial scroll position read on client only
    setScrollY(window.scrollY);
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handlerLogo = () => {
    router.push("/");
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Setting mounted state on client is intentional to avoid hydration mismatch
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <div
      className={` ${
        scrollY !== 0 || pathname !== "/"
          ? "bg-white shadow-multiShadow"
          : "bg-transparent"
      } transition-colors right-0 left-0 duration-300 fixed z-[10000]`}
      dir="rtl"
    >
      <div className="container flex justify-between items-center w-full py-3.5 h-[4.125rem] sm:h-auto headerHeight">
        {/* Desktop - md and above */}
        <div className="hidden md:flex justify-between items-center w-full">
          <div className="flex gap-6 md:gap-8 items-center flex-1">
            <Logo
              onClick={handlerLogo}
              className={`${
                scrollY === 0 && pathname === "/"
                  ? "filter invert brightness-0"
                  : ""
              }`}
            />
            <MenuStructure
              scrollY={scrollY}
              onClose={() => {}}
              isDesktop={true}
            />
          </div>
          <LoginButton title="ورود / عضویت" />
        </div>

        {/* Mobile - below md */}
        <div className="flex md:hidden w-full justify-between items-center">
          <div className="flex gap-2">
            <button
              type="button"
              onClick={showDrawer}
              className="text-base items-center justify-start w-10 h-9"
            >
              <MenuOutlined
                alt="hamburgerMenu"
                style={{
                  color:
                    scrollY !== 0 || pathname !== "/" ? "inherit" : "#ffffff",
                }}
                className="text-xl transition-colors duration-500"
              />
            </button>
            <MenuDrawer onClose={onClose} open={open} />
          </div>
          <Logo onClick={handlerLogo} 
          className={`${
                scrollY === 0 && pathname === "/"
                  ? "filter invert brightness-0"
                  : ""
              }`}/>
          <LoginButton />
        </div>
      </div>
    </div>
  );
};

export default Header;
